import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { BallotsService } from 'src/app/services/ballots.service';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-boost',
  templateUrl: './boost.component.html',
  styleUrls: ['./boost.component.scss'],
})
export class BoostComponent  implements OnInit {
  @Input() ballot: any=null;
  @Input() loggedUser: any;
  @Input() freeBoost: any;
  boostPrice=100;
  settings:any;

  constructor(private alertController:AlertController,
    private ballotsService: BallotsService,
    private userService: UserService,
    private router: Router,
    private settingsService: SettingsService) {
    }


  async ngOnInit() {
    //this.loggedUser= await this.userService.getLoggedUser();
    //console.log("Rislevato user",this.loggedUser)
    const settingData= await this.settingsService.list();
    this.settings=!!settingData ? settingData.data[0] : null;
    //console.log(this.settings)
    if (!!this.settings) {
      this.boostPrice=this.settings.boost_price;
    }

    // console.log("BALLOT",this.ballot)
    // console.log("loggedUser: ",this.loggedUser);
    // console.log("freeBoost: ",this.freeBoost);

  }

  async buyBoost(ballot: any){
    console.log("buyboost", this.loggedUser, this.ballot)
    if (!!this.loggedUser) {
      if (this.freeBoost>0) {
        this.loggedUser.boosts=this.freeBoost-1;
      } else {
        if (this.loggedUser.points>this.boostPrice) {
          this.loggedUser.points=this.loggedUser.points-this.boostPrice;
        } else{
           this.goPopupAlert();
           return;
        }
      }
      this.userService.updateUser(this.loggedUser);

      this.ballot.boosted=true;
      const res= await this.ballotsService.updateBallot({ id: this.ballot.id, boosted: true});
      console.log(res)
    }

  }

  async popBuyBoost(ballot: any) {
    const pop = await this.alertController.create({
      header: 'Booster',
      message: `VUOI ACQUISTARE UN BOOST? QUESTO BALLOTTAGGIO VERRA' MESSO IN TENDENZA E AVRA' MAGGIORE VISIBILITA' (100 CREDITI)`,
      cssClass: 'custom-alert-background',
      buttons: [{
        text: 'CONFERMA',
        role: 'confirm',
        handler: async () => {
          console.log(ballot)
          this.buyBoost(ballot);
        }
      }, {
        text: 'Annulla',
        role: 'cancel'
      }]
    });
     pop.present();
  }


  async popFreeBoost(ballot: any) {
    const pop = await this.alertController.create({
      header: 'Booster',
      message: `VUOI ACQUISTARE UN BOOST? QUESTO BALLOTTAGGIO VERRA' MESSO IN TENDENZA E AVRA' MAGGIORE VISIBILITA' (GRATIS)`,
      cssClass: 'custom-alert-background',
      buttons: [{
        text: 'CONFERMA',
        role: 'confirm',
        handler: async () => {
          console.log(ballot)
          this.buyBoost(ballot);
        }
      }, {
        text: 'Annulla',
        role: 'cancel'
      }]
    });
     pop.present();
  }


  async goPopupAlert(){
    const pop = await this.alertController.create({
      header: 'Booster',
      message: `Attenzione non hai i crediti sufficienti per l'acquisto del boost. Ricarica i crediti.`,
      cssClass: 'custom-alert-background',
      buttons: [{
        text: 'OK',
        role: 'cancel'
      }, {
        text: 'Annulla',
        role: 'cancel'
      }]
    });

     pop.present();

  }


  async guestPopBoost(){
    const pop = await this.alertController.create({
      header: 'Booster',
      message: `REGISTRATI CON EMAIL SE VUOI AUMENTARE LA VISIBILITA’ AI TUOI BALLOTTAGGI`,
      cssClass: 'custom-alert-background',
      buttons: [{
        text: 'REGISTRATI',
        role: 'confirm',
        handler: async () => {
          this.router.navigate(['/register']);
        }
      }, {
        text: 'Annulla',
        role: 'cancel'
      }]
    });

     pop.present();

  }

  async boost(ballot: any) {

    //Verifica referenze degli utenti
    if (this.userService.isUserGuest()) {
      this.guestPopBoost();
    } else {
      if (this.freeBoost>0) { this.popFreeBoost(ballot); }
        else  {this.popBuyBoost(ballot);}
    }


  }

}
